export default "__VITE_ASSET__BQCTgr7l__"